import { cva as e } from "class-variance-authority";
e("px-4 py-2 text-xs font-medium text-foreground", {
	variants: { variant: {
		bordered: "border-r border-border",
		default: ""
	} },
	defaultVariants: { variant: "default" }
}), e("px-4 py-2 text-xs text-foreground"), e("w-[50px] max-w-[50px] text-center bg-muted", {
	variants: { variant: {
		bordered: "border-r border-border",
		default: ""
	} },
	defaultVariants: { variant: "default" }
});
var t = e("text-center w-[50px]", {
	variants: { variant: {
		bordered: "border-r border-border",
		default: ""
	} },
	defaultVariants: { variant: "default" }
});
e("w-[50px] text-center bg-muted", {
	variants: { variant: {
		bordered: "border-r border-border",
		default: ""
	} },
	defaultVariants: { variant: "default" }
});
var n = e("text-center w-[50px]", {
	variants: { variant: {
		bordered: "border-r border-border",
		default: ""
	} },
	defaultVariants: { variant: "default" }
});
export { t as checkboxCell, n as expandCell };

//# sourceMappingURL=table-cva.js.map